export default "__VITE_ASSET__c8bf1b29__"